import {
  registerOverlayResetHandler,
  registerOrganizationResetHandler,
  registerSessionResetHandler,
} from '../ports/sessionResetPort';
import { hideAppToasts } from './appToast';

// Toasts son mensajes de sesión: un "Guardado" de la org anterior no debe
// sobrevivir a un logout, cambio de org ni cambio de sucursal.
registerSessionResetHandler(hideAppToasts);
registerOrganizationResetHandler(hideAppToasts);
registerOverlayResetHandler(hideAppToasts);
